import React, { useState } from 'react';
import { AvDialog, Select, TextInput } from '@fabric-ui/components';
import { AlertsFull, AssetsFull, FindingsFull, IdentitiesFull, IncidentsFull, Risk360Full, ThreatsFull } from '@fabric-ui/icons/apps';
import { flex } from '@fabric-ui/theme';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import { useAvContext } from '../../context/AvContextProvider';
import { useAllApps } from '../../hooks/useAllApps';
import { APP_PATHS } from '../../types';
import { CustomDashboardDto } from '../CustomDashboards/types';
import { renderOption } from './reports.utils';

const iconComponents = {
  VULNERABILITIES: FindingsFull,
  DETECTIONS: AlertsFull,
  INCIDENTS: IncidentsFull,
  RISK360: Risk360Full,
  ASSETS: AssetsFull,
  THREATS: ThreatsFull,
  IDENTITIES: IdentitiesFull,
};

interface Props {
  isSaveAsNewDialogOpen: boolean;
  setIsSaveAsNewDialogOpen: any;
  save: any;
  customDashboard: CustomDashboardDto;
}
const SaveAsNewDialog: React.FC<Props> = ({ isSaveAsNewDialogOpen, setIsSaveAsNewDialogOpen, customDashboard, save }) => {
  const { enabledApps } = useAvContext();
  const { data: AllApps = [] } = useAllApps();

  const [name, setName] = useState(customDashboard.name);
  const [apps, setApps] = useState<string[]>([]);

  const filteredAppsOption = enabledApps.map(({ id, name, enumValue }) => {
    const IconComponent = iconComponents[enumValue];
    return {
      value: AllApps.find(({ name }) => id === APP_PATHS[name])?.name,
      title: name,
      iconFull: IconComponent ? <IconComponent /> : undefined,
    };
  });

  return (
    <div>
      <AvDialog
        open={isSaveAsNewDialogOpen}
        onClose={() => setIsSaveAsNewDialogOpen(false)}
        title="Save As New Report"
        footer={
          <Box sx={{ ...flex.justifyEndCenter, gap: 2 }}>
            <Button onClick={() => setIsSaveAsNewDialogOpen(false)}>Cancel</Button>
            <Button
              variant="outlined"
              onClick={() =>
                save({ isRerun: true, isCreate: true, customDashboard: { ...customDashboard, name, apps }, isSaveAsNew: true })
              }
              disabled={!name}>
              Save & Run
            </Button>
            <Button
              variant="contained"
              onClick={() => save({ isCreate: true, customDashboard: { ...customDashboard, name, apps }, isSaveAsNew: true })}
              disabled={!name}>
              Save
            </Button>
          </Box>
        }>
        <Box sx={{ ...flex.col, gap: 2 }}>
          <TextInput sx={{ width: '100%', maxWidth: 'unset' }} size="small" isRequired onChange={setName} value={name} label="Name" />
          <Select
            muiProps={{ disableClearable: true }}
            label="Pin to Apps"
            isMultiple
            size="small"
            value={apps}
            onChange={setApps}
            options={filteredAppsOption as any}
            renderOption={({ title, iconFull }: any) => renderOption({ title, iconFull, sx: { svg: { width: 22, height: 22 } } })}
            style={{ '&.autocomplete-multiple': { '&, & .MuiFormControl-root': { maxWidth: '100%' } } }}
          />
        </Box>
      </AvDialog>
    </div>
  );
};

export default SaveAsNewDialog;
